import React, { Component } from "react";
import {
  Button,
  Wrapper,
  Copy,
  Bold,
  Gradient
} from "app/NativeComponents/common";

class SearchTab extends Component {
  render() {
    const { is_active, onPress, title, colors } = this.props;
    if (this.props.is_active > 0) {
      return (
        <Button onPress={onPress} style={{ marginBottom: 5 }}>
          <Gradient
            color1={colors.gradient_button_color_1}
            color2={colors.gradient_button_color_2}
            style={{
              padding: 10,
              paddingTop: 0,
              paddingBottom: 0,
              borderRadius: 30
            }}
          >
            <Copy style={{ fontSize: 10, color: colors.white_text_color }}>
              <Bold>{title}</Bold>
            </Copy>
          </Gradient>
        </Button>
      );
    }

    return (
      <Button onPress={onPress} style={{ marginBottom: 5 }}>
        <Wrapper
          style={{
            padding: 10,
            paddingTop: 0,
            paddingBottom: 0,
            borderRadius: 30
          }}
        >
          <Copy style={{ fontSize: 10 }}>
            <Bold>{title}</Bold>
          </Copy>
        </Wrapper>
      </Button>
    );
  }
}

export default SearchTab;
